import { render, staticRenderFns } from "./deposit.vue?vue&type=template&id=f9704f54"
import script from "./deposit.vue?vue&type=script&lang=js"
export * from "./deposit.vue?vue&type=script&lang=js"
import style0 from "./deposit.vue?vue&type=style&index=0&id=f9704f54&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports